import { memo } from "react";
import * as PR from "../../prime-react/index";
import { dateTimeFormat, processHtmlLinks, trimFileName } from "../../utils/reuse";


const MessageReceive = memo(({ message, index, unreadIndex, userReceive, senderImageSrc, fetchFileDetails }) => {
    const { senderID, content, attachment, createdAt, senderUserImage, senderUserName } = message ?? {};

    const renderAttachment = () => {
        if (attachment) {
            const file = JSON.parse(attachment);
            return (
                <PR.Button
                    key={file.key}
                    icon="pi pi-file"
                    label={trimFileName(file.name)}
                    className={`file-download-button ${!content ? 'report-file' : ''}`}
                    onClick={() => fetchFileDetails(file.key, file.name)}
                />
            );
        }
        return null;
    };
    const renderSenderImage = (senderUserImage, userReceive) => {
        const tooltipLabel = senderUserName || "User";

        if (senderUserImage) {
            return (
                <span title={tooltipLabel}>
                    <PR.Image src={senderImageSrc || userReceive} alt={tooltipLabel} className="chat-image group-name-icon" />
                </span>
            );
        } else {
            return (
                <span title={tooltipLabel}>
                    <PR.Image src={userReceive} alt={tooltipLabel} className="chat-image" />
                </span>
            );
        }
    };

    return (
        <div key={senderID + index}>
            {index === unreadIndex && (
                <div className="unread-ptag mb-3">
                    <p>Unread messages</p>
                </div>
            )}
            <div className="messages-wrapper">
                {content && (
                    <div className="box">
                        {renderSenderImage(senderUserImage, userReceive)}
                        <div
                            className="message receive"
                            dangerouslySetInnerHTML={{ __html: processHtmlLinks(content) }}
                        />
                    </div>
                )}
                <div className="attachment-file">
                    {!content && renderSenderImage(senderUserImage, userReceive)}
                    {renderAttachment()}
                </div>
                <span className="time">{dateTimeFormat(createdAt)}</span>
            </div>
        </div>
    );
});

export default MessageReceive;
